var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSewingMachine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95.941 78.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Machnes_and_dividers"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M94.945,29.428l-4.515,.366c-.63,.051-1.17-.447-1.17-1.079V13.105c0-.633,.54-1.13,1.17-1.079l4.515,.366c.562,.046,.995,.515,.995,1.079v14.878c0,.564-.433,1.034-.995,1.079Z",
    fill: "#e6e5ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.418,10.215v63.856c0,2.404-1.957,4.347-4.36,4.331l-81.248-.549c-2.326-.015-4.224-1.866-4.3-4.19L.04,59.208l-.038-1.18c-.032-1.023,.298-2.025,.932-2.828l1.835-2.319c.806-1.018,2.025-1.621,3.323-1.644l45.609-.774c.341-.005,.662-.09,.945-.235,.083-.042,.162-.09,.238-.142,.631-.431,1.019-1.188,.933-2.011l-1.718-16.628c-.114-1.104-1.044-1.944-2.154-1.944H29.402c-.906,0-1.716,.564-2.031,1.414l-2.581,6.975c-.314,.85-1.124,1.414-2.03,1.414H6.24c-1.147,0-2.095-.895-2.161-2.041L2.532,10.464c-.034-.576,.048-1.132,.222-1.645,.578-1.7,2.188-2.936,4.102-2.936H86.087c.313,0,.618,.034,.912,.096,1.954,.418,3.42,2.155,3.42,4.235Z",
    fill: "#d9d9db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.798,57.73l-6.199-.489c-3.373-.266-6.281-2.471-7.449-5.647l-.502-1.367c.77-.392,1.267-1.23,1.172-2.153l-1.718-16.628c-.114-1.104-1.044-1.944-2.154-1.944H29.402c-.906,0-1.716,.564-2.031,1.414l-2.581,6.975c-.314,.85-1.124,1.414-2.03,1.414h-1.04s0-12.582,0-12.582c0-1.407,1.14-2.547,2.547-2.547h24.154c4.512,0,8.509,2.912,9.892,7.206l8.485,26.346Z",
    fill: "#9b95c5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.418 1.226 64.071 2.409 63.71 6.578 53.418 6.578 53.418 1.226",
    fill: "#9b95c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.36,.491l-.914,6.858-3.448-.772V2.405c0-.156,.084-.301,.221-.377L53.718,.057c.311-.175,.689,.08,.642,.435Z",
    fill: "#d9d9db"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.591,
    cy: 23.27,
    r: 6.33,
    transform: "translate(48.77 96.352) rotate(-88.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.591,
    cy: 23.92,
    r: 6.33,
    transform: "translate(48.12 96.988) rotate(-88.788)",
    fill: "#e6e5ea"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.591,
    cy: 47.036,
    r: 6.33,
    transform: "translate(25.009 119.616) rotate(-88.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.591,
    cy: 47.686,
    r: 6.33,
    transform: "translate(24.359 120.252) rotate(-88.788)",
    fill: "#e6e5ea"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.591,
    cy: 47.686,
    r: 4.19,
    transform: "translate(24.955 120.652) rotate(-89.257)",
    fill: "#9b95c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.008,60.542c0,.435-.328,.801-.76,.85-30.558,3.407-58.884,1.945-71.327,.98-4.22-.328-7.799-.284-10.881-3.164l-.038-1.18c-.032-1.023,.298-2.025,.932-2.828l1.835-2.319c.806-1.018,2.025-1.621,3.323-1.644l45.609-.774c.341-.005,.662-.09,.945-.235,.083-.042,.162-.09,.238-.142l13.912,7.645,15.463,1.963c.213,.027,.401,.132,.535,.284,.133,.152,.213,.35,.213,.565Z",
    fill: "#e6e5ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.391,10.493c-44.135,3.472-72.127-.251-80.637-1.674,.578-1.7,2.188-2.936,4.102-2.936H86.087c.313,0,.618,.034,.912,.096,.315,2.115-1.193,4.324-3.608,4.513Z",
    fill: "#e6e5ea"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.169,
    y: 41.622,
    width: 4.786,
    height: 1.428,
    rx: 0.65,
    ry: 0.65,
    fill: "#9a9496"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.825,
    y: 48.338,
    width: 2.74,
    height: 1.428,
    rx: 0.714,
    ry: 0.714,
    fill: "#8e888c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.982 54.832 11.264 54.832 13.104 51.889 29.333 51.889 29.982 54.832",
    fill: "#9a9496"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.635,
    y: 39.538,
    width: 1.582,
    height: 13.252,
    fill: "#2d282e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.741,
    y: 39.191,
    width: 1.112,
    height: 2.239,
    fill: "#9a9496"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.025,
    y: 40.966,
    width: 4.014,
    height: 1.37,
    fill: "#9a9496"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.004,
    cy: 42.336,
    r: 1.042,
    fill: "#868084"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.498,
    y: 40.966,
    width: 2.702,
    height: 2.972,
    fill: "#b2b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.622,5.883l.027,.411c-.454,1.855-.684,3.757-.684,5.666v23.525s-2.628,0-2.628,0",
    fill: "none",
    stroke: "#2d282e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15.761 7.041 15.375 9.357 16.301 39.384",
    fill: "none",
    stroke: "#2d282e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.294,20.723c-.002,.031-.004,.048-.004,.066,0,.425,0,.85-.002,1.275,0,.045,.01,.079,.044,.112,.058,.055,.111,.116,.165,.172-.002,.007-.002,.009-.003,.01,0,.002-.003,.004-.004,.004-.304,0-.608,.002-.912,.002-.007,0-.015-.002-.029-.004,.011-.015,.018-.026,.027-.036,.045-.049,.089-.099,.136-.145,.03-.029,.039-.061,.039-.102-.001-.445,0-.89,0-1.335,0-.195,0-.391,0-.586,0-.037-.009-.065-.036-.091-.05-.05-.096-.103-.144-.155-.008-.008-.014-.018-.027-.037h.061c.244,0,.487,.001,.731-.001,.046,0,.073,.016,.099,.051,.368,.486,.738,.972,1.107,1.457,.013,.017,.027,.033,.048,.06,.003-.029,.005-.044,.005-.059,0-.409,0-.818,0-1.226,0-.035-.009-.061-.034-.085-.06-.059-.117-.121-.176-.184,.042-.015,.83-.021,.951-.007-.008,.013-.014,.024-.023,.034-.046,.051-.091,.102-.14,.15-.029,.029-.04,.061-.039,.102,.001,.465,0,.93,0,1.395,0,.173,0,.346,0,.52,0,.039,.009,.068,.037,.097,.057,.057,.11,.117,.174,.187-.031,.001-.05,.003-.068,.003-.207,0-.415-.001-.622,.001-.045,0-.073-.014-.101-.049-.323-.412-.649-.822-.973-1.233-.081-.103-.162-.205-.244-.308-.012-.015-.025-.029-.046-.052Z",
    fill: "#9d3438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.47,19.871c.022,0,.042,0,.062,0,.514,0,1.027-.004,1.541,.002,.193,.002,.377,.06,.541,.166,.132,.085,.205,.213,.242,.363,.047,.191,.047,.382,.003,.574-.043,.189-.151,.326-.325,.411-.05,.024-.102,.045-.157,.07,.013,.02,.024,.036,.036,.052,.149,.2,.298,.401,.448,.6,.021,.028,.048,.054,.076,.076,.073,.057,.148,.11,.224,.167-.046,.015-.949,.014-1.096,0,.046-.07,.09-.136,.135-.205-.012-.017-.024-.034-.036-.049-.158-.201-.316-.402-.473-.604-.023-.03-.048-.043-.086-.042-.111,.002-.222,0-.332,0-.018,0-.035,.003-.056,.004-.002,.019-.005,.034-.005,.05,0,.191,0,.383-.002,.574,0,.037,.009,.065,.035,.092,.055,.058,.108,.119,.162,.18-.04,.015-.834,.021-.944,.007,.009-.013,.016-.024,.024-.033,.05-.052,.1-.105,.152-.156,.025-.024,.035-.05,.034-.085-.001-.165,0-.33,0-.495,0-.479,0-.959,.002-1.438,0-.044-.012-.075-.043-.106-.056-.054-.107-.113-.164-.174Zm.748,1.129c.019,.002,.031,.004,.043,.004,.24,0,.479,0,.719,0,.038,0,.077-.006,.113-.015,.181-.046,.273-.214,.209-.381-.045-.119-.159-.196-.298-.197-.25-.002-.499,0-.749,0-.011,0-.023,.003-.037,.005v.585Z",
    fill: "#9d3438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.212,21.681v.671c-.046,.015-1.998,.022-2.171,.008,.009-.013,.015-.024,.024-.033,.049-.053,.098-.107,.149-.158,.023-.023,.033-.047,.033-.08,0-.646,0-1.292,0-1.939,0-.033-.009-.057-.032-.08-.05-.05-.098-.102-.146-.153-.01-.011-.019-.024-.033-.042h2.171c.012,.047,.016,.585,.005,.688-.015-.008-.029-.014-.041-.023-.049-.035-.096-.073-.146-.107-.019-.013-.044-.022-.066-.022-.38-.001-.761,0-1.141,0-.008,0-.016,.002-.023,.002-.016,.044-.019,.346-.005,.425,.018,0,.037,.003,.057,.003,.308,0,.616,0,.924,0,.039,0,.069-.009,.098-.036,.035-.034,.074-.065,.119-.104v.827c-.054-.041-.101-.074-.145-.111-.034-.029-.07-.04-.115-.04-.29,.003-.58,.004-.87,.005-.022,0-.044,0-.064,0-.016,.053-.017,.373-.002,.437h.064c.36,0,.721,0,1.081,0,.042,0,.078-.01,.113-.033,.051-.035,.104-.067,.163-.104Z",
    fill: "#9d3438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.108,22.35v-.84c.028,.019,.046,.03,.063,.043,.158,.115,.321,.221,.501,.3,.192,.085,.394,.111,.601,.094,.175-.014,.297-.113,.342-.268,.009-.031,.007-.058-.007-.087-.047-.1-.125-.166-.228-.204-.123-.045-.251-.056-.38-.06-.121-.004-.241-.014-.358-.048-.168-.049-.311-.143-.416-.277-.156-.2-.199-.443-.057-.676,.138-.226,.341-.365,.594-.433,.119-.032,.241-.047,.364-.049,.23-.003,.458,.014,.684,.06,.037,.008,.076,.014,.111,.027,.039,.015,.069,.008,.101-.015,.029-.021,.061-.037,.093-.056,.015,.044,.02,.567,.006,.684-.013-.005-.026-.009-.038-.014-.261-.122-.534-.199-.821-.227-.131-.013-.258,0-.371,.075-.027,.018-.053,.037-.076,.059-.077,.077-.079,.171-.006,.253,.045,.051,.1,.089,.165,.108,.083,.024,.167,.044,.252,.059,.135,.023,.27,.04,.405,.061,.09,.014,.175,.044,.257,.083,.066,.031,.117,.077,.16,.134,.179,.234,.196,.563,.042,.831-.073,.127-.172,.226-.305,.292-.261,.13-.537,.18-.825,.154-.149-.013-.291-.061-.429-.117-.061-.025-.123-.051-.182-.08-.028-.013-.048-.011-.071,.007-.054,.042-.11,.081-.171,.126Z",
    fill: "#9d3438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.474,20.033c.042-.045,.085-.091,.127-.136,.008,.003,.01,.004,.011,.005,.001,.001,.003,.003,.003,.004,.001,.217,.003,.435,.004,.652,0,.02,0,.04,0,.074-.026-.016-.042-.026-.057-.036-.142-.098-.292-.18-.462-.214-.118-.024-.238-.044-.358-.051-.118-.007-.231,.029-.334,.088-.259,.15-.411,.375-.433,.672-.023,.314,.184,.732,.583,.826,.232,.055,.442,0,.634-.136,.088-.062,.088-.063,.088-.172,0-.077-.001-.153,0-.23,0-.035-.009-.061-.035-.085-.057-.054-.111-.111-.167-.168,.048-.015,.748-.021,.947-.008-.01,.013-.017,.024-.025,.033-.042,.043-.083,.089-.128,.128-.039,.034-.05,.072-.05,.122,.001,.169-.003,.338-.002,.507,0,.044-.013,.076-.041,.108-.158,.184-.358,.296-.591,.354-.32,.079-.639,.081-.949-.04-.405-.159-.68-.443-.779-.872-.154-.669,.242-1.427,1.02-1.585,.259-.053,.517-.032,.767,.057,.073,.026,.142,.065,.224,.103Z",
    fill: "#9d3438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.367,22.36h-.962c.01-.014,.017-.025,.025-.034,.05-.053,.099-.106,.151-.156,.025-.024,.034-.051,.034-.085-.002-.165,0-.33,0-.495,0-.473-.001-.946,0-1.419,0-.045-.01-.08-.044-.112-.057-.053-.11-.112-.162-.166,.001-.006,.002-.008,.003-.01,0-.002,.003-.004,.004-.004,.3,0,.599,0,.899,0,.011,0,.023,.002,.042,.004-.014,.017-.022,.03-.032,.041-.045,.049-.089,.098-.136,.145-.025,.025-.035,.05-.035,.085,.002,.08,0,.161,0,.242-.001,.558-.002,1.115-.004,1.673,0,.046,.012,.08,.044,.112,.056,.055,.109,.113,.173,.18Z",
    fill: "#9d3438"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSewingMachine);
export default __webpack_public_path__ + "static/media/sewing-machine.d3034e53fb4b10108fca4601c69abcb0.svg";
export { ForwardRef as ReactComponent };